import { render, staticRenderFns } from "./detectionTemplateConfig.vue?vue&type=template&id=9ef504b8"
import script from "./detectionTemplateConfig.vue?vue&type=script&lang=js"
export * from "./detectionTemplateConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9ef504b8')) {
      api.createRecord('9ef504b8', component.options)
    } else {
      api.reload('9ef504b8', component.options)
    }
    module.hot.accept("./detectionTemplateConfig.vue?vue&type=template&id=9ef504b8", function () {
      api.rerender('9ef504b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/Nutrition/baseData/detectionTemplateConfig.vue"
export default component.exports